// extracted by mini-css-extract-plugin
export default {"headerButtonsBlock":"ActKc2DetailsToolbox_headerButtonsBlock__Cwo98"};